webpackJsonp([302],{

/***/ 1201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlatformHomeModuleForm_vue__ = __webpack_require__(2913);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06d58674_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlatformHomeModuleForm_vue__ = __webpack_require__(5197);
function injectStyle (ssrContext) {
  __webpack_require__(5195)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06d58674"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlatformHomeModuleForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06d58674_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlatformHomeModuleForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 2913:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selectLoading: false,
      form: {},
      options: {
        moduleType: [{ label: '福利社', value: 1 }, { label: '小零商城', value: 2 }, { label: '小零招聘', value: 3 }],
        moduleState: [{ label: '启用', value: 1 }, { label: '不启用', value: 0 }],
        badgeType: [{ label: '上新角标', value: 1 }],
        badgeState: [{ label: '启用', value: 1 }, { label: '不启用', value: 0 }]
      },
      moduleFormRules: {
        type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择模块类型', 'integer'))],
        status: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择模块状态', 'integer'))],
        badge_type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择角标类型', 'integer'))],
        badge_status: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择角标状态', 'integer'))],
        badge_start: [{ required: true, message: '角标开始时间不能为空', trigger: 'blur' }],
        badge_end: [{ required: true, message: '角标结束时间不能为空', trigger: 'blur' }, { validator: this.endtimeValidator, trigger: 'blur' }]
      },
      availableModule: []
    };
  },

  computed: Vuex.mapState({}),
  created: function created() {
    if (this.$route.query.module) {
      this.form = this.$route.query.module;
    }
    this.getAvailableModule();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions({}), {
    onSubmit: function onSubmit() {
      var _this = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          var data = {
            id: _this.form.id,
            type: _this.form.type,
            status: _this.form.status,
            badge_start: _this.form.badge_start,
            badge_end: _this.form.badge_end,
            badge_type: _this.form.badge_type,
            badge_status: _this.form.badge_status
          };
          if (_this.form.id === null || _this.form.id === undefined) {
            return request.common('createModule', data).then(function (data) {
              _this.$message({
                showClose: true,
                message: '保存成功',
                type: 'success'
              });
              _this.$router.push({ path: '/platform/home-module-table' });
            });
          } else {
            data.id = _this.form.id;
            return request.common('editModule', data).then(function (data) {
              _this.$message({
                showClose: true,
                message: '修改成功',
                type: 'success'
              });
              _this.$router.push({ path: '/platform/home-module-table' });
            });
          }
        } else {
          _this.$message.error('提交内容填写不正确！');
        }
      });
    },
    getAvailableModule: function getAvailableModule() {
      var _this2 = this;

      request.page('getAvailableModule').then(function (data) {
        var moduleTypes = [];
        data.data.forEach(function (module, index) {
          var moduleType = {
            label: module.name,
            value: module.type
          };
          moduleTypes.push(moduleType);
        });
        _this2.options.moduleType = moduleTypes;
      });
    },

    // 验证活动结束时间
    endtimeValidator: function endtimeValidator(rule, value, callback) {
      if (Date.parse(this.form.badge_end) <= Date.parse(this.form.badge_start)) {
        callback(new Error('角标结束时间必须晚于角标开始时间'));
      } else {
        callback();
      }
    }
  })

});

/***/ }),

/***/ 5195:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5196);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("006b7694", content, true, {});

/***/ }),

/***/ 5196:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PlatformHomeModuleForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v("\n      "+_vm._s(_vm.$route.meta.title)+"\n    ")]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("平台管理")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: '/platform/home-module-table'}}},[_vm._v("APP首页模块管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"show-header":false}},[_c('el-form',{ref:"form",staticClass:"demo-ruleForm",attrs:{"model":_vm.form,"rules":_vm.moduleFormRules,"label-width":"120px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('el-form-item',{attrs:{"prop":"type","label":"模块类型:"}},[_c('el-select',{attrs:{"placeholder":"请选择模块类型"},model:{value:(_vm.form.type),callback:function ($$v) {_vm.$set(_vm.form, "type", $$v)},expression:"form.type"}},_vm._l((_vm.options.moduleType),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"status","label":"模块状态:"}},[_c('el-select',{attrs:{"placeholder":"请选择模块状态"},model:{value:(_vm.form.status),callback:function ($$v) {_vm.$set(_vm.form, "status", $$v)},expression:"form.status"}},_vm._l((_vm.options.moduleState),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"badge_type","label":"角标类型:"}},[_c('el-select',{attrs:{"placeholder":"请选择角标类型"},model:{value:(_vm.form.badge_type),callback:function ($$v) {_vm.$set(_vm.form, "badge_type", $$v)},expression:"form.badge_type"}},_vm._l((_vm.options.badgeType),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"badge_status","label":"角标状态:"}},[_c('el-select',{attrs:{"placeholder":"请选择角标状态"},model:{value:(_vm.form.badge_status),callback:function ($$v) {_vm.$set(_vm.form, "badge_status", $$v)},expression:"form.badge_status"}},_vm._l((_vm.options.badgeState),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"badge_start","label":"角标开始时间:"}},[_c('el-date-picker',{attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetime","placeholder":"请选择角标开始时间","align":"center"},model:{value:(_vm.form.badge_start),callback:function ($$v) {_vm.$set(_vm.form, "badge_start", $$v)},expression:"form.badge_start"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"badge_end","label":"角标结束时间:"}},[_c('el-date-picker',{attrs:{"type":"datetime","format":"yyyy-MM-dd HH:mm:ss","value-format":"yyyy-MM-dd HH:mm:ss","placeholder":"请选择角标结束时间"},model:{value:(_vm.form.badge_end),callback:function ($$v) {_vm.$set(_vm.form, "badge_end", $$v)},expression:"form.badge_end"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("新建\n        ")]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/platform/home-module-table'}}},[_c('el-button',[_vm._v("取消")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/platform-home-module-form.86a4837c1241165292ec.js